export const getTableHeaderClass = (theme) =>
  `${theme === 'dark' ? 'table-dark' : 'table-secondary'} modern-table__head-row`;

export const getModernDataTableClass = (theme) => {
  const tone = theme === 'dark' ? 'modern-data-table--dark' : 'modern-data-table--light';
  const surface = theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark';
  return `modern-data-table ${tone} ${surface}`;
};

export const getModernCardHeaderClass = (theme) =>
  `${theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'} modern-data-table__header`;

export const getModernCardBodyClass = (theme) =>
  `${theme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'} modern-data-table__body`;

export const getModernCardFooterClass = (theme) =>
  `${theme === 'dark'
    ? 'bg-dark text-light border-secondary'
    : 'bg-light text-dark'} modern-data-table__footer d-flex justify-content-between align-items-center`;

export const getModernTableClass = (theme) =>
  `modern-table ${theme === 'dark' ? 'table-dark' : ''}`.trim();

export const getModernDataTableMetaClass = () => 'modern-data-table-meta text-muted';

export const getThemeFormControlClass = (theme) =>
  theme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark';

export const getModalHeaderClass = (theme) =>
  theme === 'dark'
    ? 'bg-dark text-light border-bottom border-secondary'
    : 'bg-light text-dark';

export const getModalFooterClass = (theme) =>
  theme === 'dark'
    ? 'bg-dark text-light border-top border-secondary'
    : 'bg-light text-dark';
